// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offer-form":"fa4EaasX9IR70PKVqXSx","row":"VgcVYfnAguzO2YUZO0Ju","full":"i7AGPeMJOQa1Q6pA7vsm","half":"fLSQFDiyNy7IcDaHopYX"};